import React, { useState } from "react";

const ServiceCard = ({
    id,
    title,
    rating,
    bookings,
    points,
    image,
    price,
    oldPrice,
}) => {
    const [showMore, setShowMore] = useState(false);

    return (
        <div className="service-card" id={id}>

            {/* LEFT CONTENT */}
            <div className="service-info">

                <h3 className="service-title">
                    {title}
                </h3>

                {/* Rating */}
                <div className="rating-row">

                    <div className="rating-box">
                        <span className="star">★</span>

                        <span className="rating-value">
                            {rating}
                        </span>
                    </div>

                    <span className="bookings">
                        ({bookings} Bookings)
                    </span>

                </div>


                {/* Service Points */}
                <ul className="service-points">

                    {points
                        .slice(0, showMore ? points.length : 2)
                        .map((point, index) => (
                            <li key={index}>
                                <span className="point-icon">
                                    •
                                </span>

                                <span>
                                    {point}
                                </span>
                            </li>
                        ))}

                </ul>


                {/* Show More */}
                {points.length > 2 && (
                    <button
                        type="button"
                        className="show-more"
                        onClick={() => setShowMore(!showMore)}
                    >
                        {showMore ? "Show Less" : "Show More"}
                    </button>
                )}

            </div>


            {/* RIGHT CONTENT */}
            <div className="service-actions">

                {/* Image */}
                <div className="service-image">
                    <img
                        src={image}
                        alt={title}
                        loading="lazy"
                    />
                </div>


                {/* Add To Cart */}
                <button
                    type="button"
                    className="cart-btn"
                    onClick={() => {
                        console.log("Added to cart:", title);
                    }}
                >
                    Add to Cart
                </button>


                {/* Price */}
                <div className="price-row">

                    <span className="price">
                        ₹{price}
                    </span>

                    <span className="old-price">
                        ₹{oldPrice}
                    </span>

                </div>

            </div>

        </div>
    );
};

export default ServiceCard;